export const MOBILE_COMPATIBILITY_QUERY_PARAM = 'dohockey-mobile-handoff';

export type MobileCompatibilityHandoff = {
  cleanPath: string;
  routeGroup: string;
};

const getRouteGroup = (pathname: string): string => {
  if (pathname === '/') return 'dugout';
  if (pathname === '/login' || pathname === '/auth/verify' || pathname === '/register') return 'auth';
  if (pathname.startsWith('/match')) return 'match';
  if (pathname.startsWith('/team')) return 'team';
  if (pathname.startsWith('/training-') || pathname.startsWith('/plans/')) return 'training';
  if (pathname.startsWith('/dashboard')) return 'administration';
  if (
    pathname.startsWith('/share/')
    || pathname.startsWith('/trainer/share/')
    || pathname.startsWith('/trainer/offline')
    || pathname.startsWith('/trainer/viewer')
    || pathname.startsWith('/intake')
    || pathname.startsWith('/evaluation-')
  ) return 'public-workflow';
  return 'other';
};

export const markMobileCompatibilityHandoff = (url: URL): URL => {
  url.searchParams.set(MOBILE_COMPATIBILITY_QUERY_PARAM, '1');
  return url;
};

export const consumeMobileCompatibilityHandoff = (
  currentUrl: string,
): MobileCompatibilityHandoff | null => {
  try {
    const url = new URL(currentUrl);
    if (url.searchParams.get(MOBILE_COMPATIBILITY_QUERY_PARAM) !== '1') return null;
    url.searchParams.delete(MOBILE_COMPATIBILITY_QUERY_PARAM);
    return {
      cleanPath: `${url.pathname}${url.search}${url.hash}`,
      routeGroup: getRouteGroup(url.pathname),
    };
  } catch {
    return null;
  }
};
